module.exports = __webpack_public_path__ + "img/远离热源.e9d4fa4a.jpg";